var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Media Links"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.36 6H6.64C6.286 6 6 6.286 6 6.64V21.36C6 21.714 6.286 22 6.64 22H21.36C21.714 22 22 21.714 22 21.36V6.64C22 6.286 21.714 6 21.36 6ZM18.306 11.794C18.312 11.888 18.312 11.986 18.312 12.082C18.312 15.018 16.076 18.4 11.99 18.4C10.73 18.4 9.562 18.034 8.578 17.404C8.758 17.424 8.93 17.432 9.114 17.432C10.154 17.432 11.11 17.08 11.872 16.484C10.896 16.464 10.076 15.824 9.796 14.944C10.138 14.994 10.446 14.994 10.798 14.904C10.2955 14.8019 9.84375 14.529 9.51963 14.1316C9.19551 13.7342 9.01897 13.2368 9.02 12.724V12.696C9.314 12.862 9.66 12.964 10.022 12.978C9.71768 12.7752 9.46812 12.5004 9.29542 12.1781C9.12273 11.8557 9.03225 11.4957 9.032 11.13C9.032 10.716 9.14 10.338 9.334 10.01C9.8918 10.6967 10.5879 11.2583 11.3769 11.6583C12.166 12.0584 13.0304 12.2879 13.914 12.332C13.6 10.822 14.728 9.6 16.084 9.6C16.724 9.6 17.3 9.868 17.706 10.3C18.208 10.206 18.688 10.018 19.116 9.766C18.95 10.28 18.602 10.714 18.14 10.988C18.588 10.94 19.02 10.816 19.42 10.642C19.118 11.086 18.74 11.48 18.306 11.794Z",
    fill: "#D3DADD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitterIcon.6fe4b44bfa3c1507eb6ada4b4a0d7594.svg";
export { ForwardRef as ReactComponent };